import React from 'react';

import styled from '@emotion/styled';
import { mq, green01, black01, text } from '../../_style';

const Container = styled.div`
  ${mq.pc} {
    display: flex;
  }
  & > * {
    ${mq.pc} {
      width: calc((100% - 24px * 2) / 3);
    }
    & + * {
      ${mq.pc} {
        margin-left: 24px;
      }
      ${mq.sp} {
        margin-top: 15px;
      }
    }
  }
`;

export default class StoreBtnGroup extends React.Component {
  render() {
    return <Container>{this.props.children}</Container>;
  }
}
